/*
 * Copyright (c) 2025, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { ApiKeyV2, ApiKeyV2WithKey } from "../../data/interfaces"
import { DELETE_API_KEY_FAILURE, DELETE_API_KEY_REQUEST, DELETE_API_KEY_SUCCESS, FETCH_API_KEYS_FAILURE, FETCH_API_KEYS_REQUEST, FETCH_API_KEYS_SUCCESS, GENERATE_API_KEY_FAILURE, GENERATE_API_KEY_REQUEST, GENERATE_API_KEY_SUCCESS, REGENERATE_API_KEY_FAILURE, REGENERATE_API_KEY_REQUEST, REGENERATE_API_KEY_SUCCESS } from "../types/apiKeys"

export const fetchApiKeysRequest = () => {
    return {
        type: FETCH_API_KEYS_REQUEST
    }
}

export const fetchApiKeysSuccess = (apiKeys: ApiKeyV2[]) => {
    return {
        type: FETCH_API_KEYS_SUCCESS,
        payload: apiKeys
    }
}

export const fetchApiKeysFailure = (error: string) => {
    return {
        type: FETCH_API_KEYS_FAILURE,
        payload: error
    }
}

export const generateApiKeyV2Request = () => {
    return {
        type: GENERATE_API_KEY_REQUEST
    }
}

export const generateApiKeyV2Success = (apiKey: ApiKeyV2WithKey) => {
    return {
        type: GENERATE_API_KEY_SUCCESS,
        payload: apiKey
    }
}

export const generateApiKeyV2Failure = (error: string) => {
    return {
        type: GENERATE_API_KEY_FAILURE,
        payload: error
    }
}

export const regenerateApiKeyV2Request = () => {
    return {
        type: REGENERATE_API_KEY_REQUEST
    }
}

export const regenerateApiKeyV2Success = (apiKey: ApiKeyV2WithKey) => {
    return {
        type: REGENERATE_API_KEY_SUCCESS,
        payload: apiKey
    }
}

export const regenerateApiKeyV2Failure = (error: string) => {
    return {
        type: REGENERATE_API_KEY_FAILURE,
        payload: error
    }
}

export const revokeApiKeyV2Request = () => {
    return {
        type: DELETE_API_KEY_REQUEST
    }
}

export const revokeApiKeyV2Success = () => {
    return {
        type: DELETE_API_KEY_SUCCESS
    }
}

export const revokeApiKeyV2Failure = (error: string) => {
    return {
        type: DELETE_API_KEY_FAILURE,
        payload: error
    }
}
